import ChangeNotification from "@/views/changeNotification/ChangeNotification.vue";
import type { RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  distributor: "ChangeNotification.Distributor",
  distributorNew: "ChangeNotification.DistributorNew",
  distributorNewWithId: "ChangeNotification.DistributorNewWithId",
};

export { names as changeNotificationRouteNames };

const changeNotificationRoutes: RouterOptions["routes"] = [
  {
    path: "/distributor-change-notification",
    name: names.distributor,
    meta: { title: "Distributor Change Notification New", isNew: true },
    children: [
      {
        path: "",
        name: names.distributorNew,
        meta: { title: "Distributor Change Notification New", isNew: true },
        component: {
          render: () => <ChangeNotification entityLabel="Distributor" />,
        },
      },
      {
        path: ":distributorId(\\d+)?",
        name: names.distributorNewWithId,
        meta: { title: "Distributor Change Notification New", isNew: true },
        component: {
          render: () => <ChangeNotification entityLabel="Distributor" />,
        },
      },
    ],
  },
];
export default changeNotificationRoutes;
